import {Renderer as BaseRenderer} from "prosemirror-to-html-js";
import Bold from 'prosemirror-to-html-js/src/Marks/Bold';
import Code from 'prosemirror-to-html-js/src/Marks/Code';
import Italic from 'prosemirror-to-html-js/src/Marks/Italic';
import Blockquote from 'prosemirror-to-html-js/src/Nodes/Blockquote';
import BulletList from '../Nodes/BulletList';
import CodeBlock from '../Nodes/CodeBlock';
import Heading from '../Nodes/Heading';
import HeadingSimple from '../Nodes/HeadingSimple';
import ListItem from '../Nodes/ListItem';
import OrderedList from '../Nodes/OrderedList';
import Paragraph from '../Nodes/Paragraph';
import ParagraphSimple from '../Nodes/ParagraphSimple';
import InlineParagraph from '../Nodes/InlineParagraph';
import Highlight from '../Marks/Highlight';
import TextSize from '../Marks/TextSize';
import TextStyle from '../Marks/TextStyle';
import Image from '../Nodes/Image';
import Link from '../Marks/Link';
import LinkExternal from '../Marks/LinkExternal';
import Strikethrough from '../Marks/Strikethrough';
import Underline from '../Marks/Underline';
import Personalisation from '../Nodes/Personalisation';
import HardBreak from "../Nodes/HardBreak";
import HorizontalRule from "../Nodes/HorizontalRule";
import {isJson} from "../verifyJSON";
export default class Renderer extends BaseRenderer {
  constructor (options) {
    super();
    this.document = undefined;
    // Choose paragraph and heading nodes based on options
    const ParagraphNode = options && options.inline ? InlineParagraph : (options?.simple ? ParagraphSimple : Paragraph);
    const HeadingNode = options?.simple ? HeadingSimple : Heading;
    
    this.nodes = [
      Blockquote,
      BulletList,
      CodeBlock,
      HeadingNode,
      HardBreak,
      HorizontalRule,
      ListItem,
      OrderedList,
      ParagraphNode,
      Image,
      HardBreak,
      Personalisation,
    ];
    
    if ( options?.simple ) {
      this.nodes = [
        ParagraphNode,
        HeadingNode,
        HardBreak,
        Personalisation,
      ];
    } else if ( options?.imageOnly ) {
      this.nodes = [
        Image,
      ];
    }
    if ( options && options.nodes ) {
      this.nodes.push(...options.nodes);
    }
    this.marks = [
      Bold,
      Code,
      Italic,
      Highlight,
      TextSize,
      TextStyle,
      Strikethrough,
      Underline,
    ];
    this.marks.push(options && options.noInternalLinks ? LinkExternal : Link);
    
    if ( options?.simple ) {
      this.marks = [
        Bold,
        Italic,
        Underline,
        Strikethrough,
      ];
      this.marks.push(options.noInternalLinks ? LinkExternal : Link);
    }
    
    if ( options && options.noNodes ) {
      this.nodes = [
        Personalisation,
      ];
      if ( options && options.inline ) {
        this.nodes.push(InlineParagraph);
      }
      this.marks = [];
    }
  }
  render(value) {
    return ( isJson(value) ) ? super.render(value) : value;
  }
}
